import { configure } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import fr from '@vee-validate/i18n/dist/locale/fr.json'
import en from '@vee-validate/i18n/dist/locale/en.json'

/**
 * Messages de validation des formulaires.
 *
 * Les deux langues sont chargées d'emblée : les dictionnaires pèsent quelques kilo-octets, alors
 * qu'un chargement à la demande laisserait le premier formulaire rempli après un changement de
 * langue afficher ses erreurs dans l'ancienne.
 */
export class VeeValidate {
  /**
   * `locale` vient du choix restauré au démarrage, et n'est pas figé au français : l'initialisation
   * passe après la création de l'instance i18n, et imposer une langue ici écraserait celle que
   * l'utilisateur avait retenue.
   */
  static init(locale: string) {
    configure({
      generateMessage: localize({ fr, en }),
    })
    setLocale(locale)
  }

  /** Aligne les messages de validation sur la langue de l'interface (voir appliquerLocale). */
  static setLocale(locale: string) {
    setLocale(locale)
  }
}
